import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "col-12 text-right" }

import { api } from '@/utils';
import { Category } from '@/models/category';
import { Formula } from '@/models/formula';
import { CategoryFormula } from '@/models/category-formula';
import FormulaAdjustTable from './FormulaAdjustTable.vue';
import { plainToInstance } from 'class-transformer';
import { ref, onMounted, computed, watch } from 'vue';
import { Substance } from '@/models/substance';
import Create from '@/components/Create.vue';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { useRoute } from 'vue-router';
import { ReportAnalysisItem } from '@/models/report-analysis-item';
import store from '@/store';


interface Props {
  title: string;
  category: Category | null;
  formula?: Formula | null;
  formulas: Formula[];
  substances: Substance[];
  index: number;
  formulasUsadas?: CategoryFormula[] | null;
}

interface Emits {
  (e: 'sendDataToRecomendationsComponent', data: any): void;
}

interface Substances {
  thisTableId: number;
  substances: number[];
}

type SubstancesArray = Substances[];


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    category: null,
    formula: null,
    formulas: null,
    substances: null,
    index: null,
    formulasUsadas: null
  },
  emits: ["sendDataToRecomendationsComponent"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'sendDataToRecomendationsComponent', data: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  title: string;
  category: Category | null;
  formula?: Formula | null;
  formulas: Formula[];
  substances: Substance[];
  index: number;
  formulasUsadas?: CategoryFormula[] | null;
}



const quasar = useQuasar();
const route = useRoute();


let arraysSubstances = ref<SubstancesArray>([]);
let arrayAppliedInfo = [];

const reportAnalysisItems = ref<ReportAnalysisItem[]>([]);
const formulas = ref<Formula[]>([]);
const substancesAux = ref<Substance[]>([]);

const categories = ref<Category[]>([]);

const modalCreate = ref<InstanceType<typeof Create> | null>(null);

const formulasUsadas = ref<CategoryFormula[]>([]);

let n_tables = ref<number>(1);

function getDataFromTable(data) {

  const result = arraysSubstances.value.find((dado) => dado.thisTableId === data.thisTableId);
  const resultApplied = arrayAppliedInfo.find((dado) => dado.thisTableId === data.thisTableId);

  if (result) {
    arraysSubstances.value = arraysSubstances.value.filter(
      (item) => item.thisTableId !== data.thisTableId
    );
    arraysSubstances.value.push(data);
  } else {
    arraysSubstances.value.push(data);
  }

  if (resultApplied) {
    arrayAppliedInfo = arrayAppliedInfo.filter(
      (item) => item.thisTableId !== data.thisTableId
    );
    arrayAppliedInfo.push(data);
  } else {
    arrayAppliedInfo.push(data);
  }

  let arr = {
    thisTablesId: props.index,
    thisTablesTitle: props.title,
    substances: sumValuesFromTables(arraysSubstances.value),
    applied: arrayAppliedInfo,
  };

  emit('sendDataToRecomendationsComponent', arr);
}

const getFormulas = () => {

  api.get('category').then((response) => {
    categories.value = plainToInstance(Category, response.data);
  });

};

getFormulas();

const createdNewFormula = () => {
  console.log("Teste...");
  quasar.loading.show();
  api
    .get(`report/${route.params.id}/recomendations`)
    .then((response) => {

      quasar.loading.hide();
      
      reportAnalysisItems.value = plainToInstance(ReportAnalysisItem, response.data.analysisItems);
      formulas.value = plainToInstance(Formula, response.data.formulas);
      substancesAux.value = plainToInstance(Substance, response.data.substances);

      store.dispatch('getRecomendationsFromAPI', {
        formulas: formulas.value,
        substances: substancesAux,
        reportAnalysisItems: reportAnalysisItems,
      });
    })
    .catch((error) => {
      quasar.loading.hide();
      console.log('Erro ao obter dados de recomendações do teste.', error.response);
    });
};



function sumValuesFromTables(arr) {
  let sumTables = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  arr.forEach(function (item) {
    for (let i = 0; i < 12; i++) {
      if (typeof item.substances[i].value != 'undefined') {
        sumTables[i] = sumTables[i] + parseFloat(item.substances[i].value);
      }
    }
  });

  return sumTables;
}

function setMoreTableByCategory(thisTableId: number){
  let count: number = 0;

  props.formulasUsadas?.forEach((cat_formula) => {
    if(cat_formula.thisTablesId == thisTableId){
      formulasUsadas.value.push(cat_formula);
      count++;
    }
  });
  if(count >= 1){
    n_tables.value =+ count 
  }
}
setMoreTableByCategory(props.index);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(props.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(n_tables), (i) => {
        return (_openBlock(), _createBlock(FormulaAdjustTable, {
          key: i,
          index: i,
          category: props.category,
          formulas: props.formulas,
          substances: props.substances,
          formula_usada: formulasUsadas.value,
          onSendDataToTablesComponent: getDataFromTable
        }, null, 8, ["index", "category", "formulas", "substances", "formula_usada"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: "link_addTable",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (modalCreate.value?.open()))
      }, " + Adicionar nova fórmula"),
      _createElementVNode("a", {
        class: "link_addTable",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(n_tables) //@ts-ignore
 ? n_tables.value++ : n_tables++))
      }, " + Adicionar Tabela")
    ]),
    _createVNode(Create, {
      ref_key: "modalCreate",
      ref: modalCreate,
      categories: categories.value,
      substances: __props.substances,
      onCreated: createdNewFormula
    }, null, 8, ["categories", "substances"])
  ], 64))
}
}

})